export const DOUGS_PARTNER_CODE = 'dougs-dougs-comptepro-526';
export const DOUGS_PARTNER_NAME_PROD = 'Dougs - Compte Pro';
// Confirmed against the real staging `Partner` records (2026-09-08) — both
// carry a "DOUGS - " prefix that prod's record doesn't have.
export const DOUGS_PARTNER_NAME_STAGING = 'DOUGS - Dougs Pro Account Staging';
export const DOUGS_PARTNER_NAME_STAGING_EMBED = 'DOUGS - Dougs - Compte Pro (Embed)';
export const DOUGS_PARTNER_DISPLAY_NAME = 'Dougs';
// Values the `partner_name` API field can hold for the Dougs embed partner,
// depending on environment/data.
export const DOUGS_PARTNER_IDENTIFIERS = [
  DOUGS_PARTNER_CODE.toLowerCase(),
  DOUGS_PARTNER_NAME_PROD.toLowerCase(),
  DOUGS_PARTNER_NAME_STAGING.toLowerCase(),
  DOUGS_PARTNER_NAME_STAGING_EMBED.toLowerCase(),
];
